module.exports = __webpack_public_path__ + "img/icon-question-edit.19438797.svg";